import React from "react";

export type TypesType =
  | { [key: string]: { [key: string]: string } }
  | undefined;

export const TypesContext = React.createContext<TypesType>(undefined);
